import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error('Enter your email');
    setLoading(true);
    try {
      await api.post('/auth/password/request', { email });
      setSent(true);
      toast.success('If that email exists, a reset link has been sent.');
    } catch { toast.error('Please try again'); }
    finally { setLoading(false); }
  };

  return (
    <div className='min-h-[80vh] indus-container py-10 flex items-center justify-center'>
      <Card className='w-full max-w-md p-8'>
        <h1 className='text-xl font-semibold'>Forgot password</h1>
        <p className='text-sm text-muted-foreground mt-1'>We’ll email you a link to reset it. Link expires in 30 minutes.</p>
        {sent ? (
          <div className='mt-6 p-4 rounded-lg bg-secondary text-sm'>
            If an account exists for <strong>{email}</strong>, a password reset link has been sent. Please check your inbox and spam folder.
          </div>
        ) : (
          <form onSubmit={submit} className='mt-6 space-y-3'>
            <div>
              <Label>Email</Label>
              <Input type='email' data-testid='forgot-email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='you@company.com' />
            </div>
            <Button type='submit' className='w-full' disabled={loading} data-testid='forgot-submit'>
              <Mail className='h-4 w-4 mr-1.5' /> {loading ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}
        <div className='mt-4 text-xs text-center text-muted-foreground'>
          Remembered it? <Link to='/login' className='text-primary hover:underline'>Sign in</Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
